import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function EmissionClassSelect() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="choice"
      name="emissionClass"
      label={i18n.t('entity.vehicle.labels.emissionClass')}
      options={catalogueApi?.emissionClassOptions ?? []}
    />
  );
}
